<template>
	<div class="lastUpdate">
		<p>{{txt.lastUpdate}}: {{lastUpdatedFormatted}}</p>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	name: 'lastUpdated',
	props: {
		lastUpdated: {
			required: true,
		},
	},
	data() {
		return {
			txt: {
				lastUpdate: 'Last data update at',
			},
			dateFormat: 'YYYY-MM-DD hh:mm:ss',
		}
	},
	computed: {
		lastUpdatedFormatted() {
			// i like this line how it is - every linting guideline makes it only more unreadable IMO
			// eslint-disable-next-line max-len, no-constant-condition
			return (typeof (this.lastUpdated == 'string')) ? this.lastUpdated : moment(this.lastUpdated).format(this.dateFormat)
		},
	},

}
</script>

<style scoped>

.lastUpdate{
	float: right;
	padding: 10px;
	padding-top: 30px;
	color: rgba(0, 0, 0, 0.7);
}

</style>
